// @flow

import React from 'react'

import styled from 'styled-components'

import usersIcon from '../../Icons/icon-users-solid.svg'
import arrowUp from '../../Icons/icon-long-arrow-alt-up-solid.svg'
import arrowDown from '../../Icons/icon-long-arrow-alt-down-solid.svg'

import Row from 'michelangelo/dist/Components/Row'
import Column from 'michelangelo/dist/Components/Column'

const ValueHeader = styled.span`
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
`
const TitleHeader = styled.span`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-transform: uppercase;
  color: #758192;
`
const PercentageBar = styled.span`
  border-radius: 5px;
  width: 100%;
  background-color: #CDD5DE;
  height: 5px;
  margin-top: 50px;
  display: block;
`
const Image = styled.img`
  height: 50px;
`

type Props = {
  value: number,
  title: string,
  maxThreshold: number,
  minThreshold: number,
  invert: boolean,
  users: boolean
}

function DynamicInfoBlock ({ value, title, maxThreshold, minThreshold, invert, users }: Props) {
  const redColor = '#F07B7B'
  const greenColor = '#0ABD63'

  maxThreshold = Math.max(1, maxThreshold)

  let completed = (value >= maxThreshold ? 1 : value / maxThreshold)
  completed *= 100

  const background = invert
    ? (value >= maxThreshold
        ? redColor
        : value >= minThreshold ? redColor : greenColor)
    : (value >= maxThreshold
        ? greenColor
        : value >= minThreshold ? greenColor : redColor)

  const fillerStyles = {
    height: '100%',
    width: `${completed}%`,
    backgroundColor: background,
    transition: 'width 1s ease-in-out'
  }

  let image = users ? usersIcon : null
  if (image === null) {
    image = (value >= maxThreshold ? arrowUp : value >= minThreshold ? arrowUp : arrowDown)
  }

  return (
    <div className='BlockItem' style={{ minHeight: '155px' }}>
      <Row>
        <Column classNames={['is-9 is-9-desktop']}>
          <ValueHeader>{value}</ValueHeader><br />
          <TitleHeader>{title}</TitleHeader>
        </Column>
        <Column classNames={['is-3 is-3-desktop']}>
          <Image src={image} />
        </Column>
      </Row>
      <Row>
        <Column classNames={['is-12 is-12-desktop']}>
          <PercentageBar>
            <div style={fillerStyles} />
          </PercentageBar>
        </Column>
      </Row>
    </div>
  )
}

export default DynamicInfoBlock
